import { Stack } from '@mui/material';
import { OrderTypes } from '../../../common/enums/enums';
import ActionsByOrder from './ActionsByOrder';
import OrdersDetails from './OrdersDetails';

export default function ListOfDetails({ order }) {
  return (
    <Stack gap={2} m={{ xs: 2, md: 0 }}>
      <Stack gap={1}>
        {order.relatedOrders
          .filter(
            relatedOrder => relatedOrder.orderType !== OrderTypes.RECONDITIONING
          )
          .map(singleOrder => (
            <OrdersDetails
              key={singleOrder.vendorOrderId}
              order={singleOrder}
            />
          ))}
      </Stack>
      <ActionsByOrder order={order} />
    </Stack>
  );
}
